// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--lKu8A5J64bwmUbBq"};